import * as React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  Toolbar,
  SaveButton,
  SelectInput,
  required,
  SelectArrayInput,
  ReferenceArrayInput,
  BooleanInput,
} from "react-admin";
import { useTimezones } from "../../hooks/organisations/useTimezones";
import { valueArrayToObject } from "../common/utils";
import { useCurrencies } from "../../hooks/organisations/useCurrencies";
import { ORGANISATIONS_SKINS } from "./organisation-skins";

const OrganisationEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
);

export const OrganisationEdit = (props) => {
  const timezones = useTimezones();
  const currencies = useCurrencies();

  return (
    <Edit 
      {...props} 
      redirect="show"
    >
      <SimpleForm toolbar={<OrganisationEditToolbar />}>
        <TextInput source="name" validate={[required()]} />
        <SelectInput
          source="timezone"
          choices={timezones}
          optionText="timezone"
          optionValue="timezone"
          validate={[required()]}
        />
        <ReferenceArrayInput
          label="BDM users"
          source="bdmIds"
          reference="internal-users"
          perPage={100}
          filter={{ userType: "INTERNAL" }}
        >
          <SelectArrayInput source="id" optionText="email" />
        </ReferenceArrayInput>
        <BooleanInput 
          label="Add Skills" 
          source="skills" 
          defaultValue={false}
        />
        <BooleanInput source="openForPollination" validate={[required()]} />
        <TextInput
          label="Billing Data Email"
          source="billingData.email"
          validate={[required()]}
        />
        <SelectInput
          source="billingData.currency"
          choices={valueArrayToObject(currencies)}
          validate={[required()]}
        />
        <TextInput
          label="SSO Microsoft Tenant Id"
          source="ssoData.msEntraTenantId"
        />
        <SelectInput
          choices={valueArrayToObject(ORGANISATIONS_SKINS)}
          source="skin"
          validate={[required()]}
        />
      </SimpleForm>
    </Edit>
  );
};
